import Vue from 'vue';

export const OPEN_HANDLER = 'open_handler';
export const VERIFY_ERROR = 'verify_error';
export const CHANGE_HIGHPRIORITY_CHECKED_STATUS =
  'change_highpriority_checked_stauts';

export const eventHub = new Vue({});
